"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchEnvironmentActivation = void 0;
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unused-vars */
const Activation_1 = require("./Activation");
class TouchEnvironmentActivation extends Activation_1.Activation {
    constructor(options) {
        super(options);
        this.initialElTop = 0;
        this.currentElTop = 0;
    }
    touchStarted(event) {
        throw new Error('NotYetImplemented');
    }
    touchMoved(event) {
        throw new Error('NotYetImplemented');
    }
    touchEnded() {
        this.deactivate();
    }
    touchCanceled() {
        this.deactivate();
    }
}
exports.TouchEnvironmentActivation = TouchEnvironmentActivation;
//# sourceMappingURL=TouchEnvironmentActivation.js.map